import React from 'react';
import {
    Row, Tag, Button, Select,
} from 'antd';

// const { Option } = Select;

export default function Ailment(props) {
    const {
        header, ailments, ailValue, onAilChange, onAilSelect, onAilSubmit,
        ailmentOptions, deleteAil, handleSpecChange, spec, specialitiesOption, inputAil,
    } = props;

    return (
        <div>
            <Row style={{ textAlign: 'center' }}>
                <div>
                    <h6>{header}</h6>
                </div>
            </Row>
            <Row>
                <div style={{ minHeight: 100 }}>
                    {
                        ailments.map(pa => (
                            <Tag key={pa.id} color="blue" closable style={{ margin: 5 }} onClose={() => deleteAil(pa.id)}>{pa.name}</Tag>
                        ))
                    }
                </div>
            </Row>
            <Row>
                <Select
                    value={spec}
                    showSearch
                    style={{ width: 200 }}
                    placeholder="Select a Speciality"
                    optionFilterProp="children"
                    onChange={handleSpecChange}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}

                >
                    {specialitiesOption}
                </Select>
            </Row>

            <br />

            <Row style={{ textAlign: 'center' }}>
                <div>
                    <Select
                        showSearch
                        value={ailValue}
                        onSearch={onAilChange}
                        style={{ width: 200 }}
                        optionFilterProp="children"
                        onChange={onAilSelect}
                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        {ailmentOptions}
                    </Select>
                </div>
            </Row>

            <br />

            <Row style={{ textAlign: 'center' }}>
                <input
                    type="text"
                    ref={inputAil}
                />
            </Row>

            <Button onClick={onAilSubmit} style={{ marginTop: 10 }} type="primary">Create</Button>

        </div>
    );
}



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/Ailment.js